import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const carriers = [
  {
    name: "Aetna",
    id: "AE-9920-X",
    icon: "shield",
    link: "https://www.aetnaseniorproducts.com/ssibrokerwebaz/agent/home?channel=broker",
  },
  {
    name: "American Amicable",
    id: "AA-8821-M",
    icon: "briefcase-medical",
    link: "https://www.insuranceapplication.com/cgi/webappmobile/login.aspx?ReturnUrl=%2fcgi%2fwebappmobile%2f",
  },
  {
    name: "NLG",
    id: "AH-4412-K",
    icon: "briefcase-medical",
    link: "https://nlg-prod.auth0.com/login?state=hKFo2SBhOFlEZk5rWEgwU2c4dXBUV2pOMFQxem9OUmFsdEVmb6FupWxvZ2luo3RpZNkgUFRiVzMxM2pjLXhUMGVwelV1TWk4LURTaHphWk9rRzajY2lk2SBNeUdxTjREc2doa3ZwNjV6VldybWtVUGM5cU5JeVpyUg&client=MyGqN4Dsghkvp65zVWrmkUPc9qNIyZrR&protocol=oauth2&redirect_uri=https%3A%2F%2Fwww.nationallife.com%2Fagent%2Fauth%2Flogincallback&response_type=code%20id_token&scope=openid%20profile%20email&response_mode=form_post&nonce=639144973966835456.OGE2YjAwMDktM2QyMC00YjlhLThmZTQtNGEzNTljZmJjMzk5ZDA3ZjRlMzItOTJhNi00YzhlLTlmZjgtNGJlMmE0YThhOTk1&connection=NLGAgentsDB&audience=https%3A%2F%2Fapi.nlg.net%2Fagent-portal&x-client-SKU=ID_NET461&x-client-ver=5.7.0.0",
  },
  {
    name: "Americo",
    id: "AM-0091-Q",
    icon: "shield-check",
    link: "https://portal.americoagent.com/",
  },
  {
    name: "Athene",
    id: "AT-7732-S",
    icon: "users",
    link: "https://www.athene.com/producer/login",
  },
  {
    name: "Corebridge (AIG)",
    id: "CB-5310-B",
    icon: "building-bank",
    link: "https://www.connext.corebridgefinancial.com/life/connext-portal/public/login",
  },
  {
    name: "Ethos",
    id: "ET-1129-V",
    icon: "leaf",
    link: "https://agents.ethoslife.com/dashboard",
  },
  {
    name: "F&G",
    id: "FG-5582-E",
    icon: "users",
    link: "https://saleslink.fglife.com/",
  },
  {
    name: "Foresters",
    id: "FO-1209-A",
    icon: "asterisk",
    link: "https://myezbiz.foresters.com/my.policy",
  },
  {
    name: "Instabrain",
    id: "IB-9912-P",
    icon: "brain",
    link: "https://portal.instabrain.io/Account/Login",
  },
  {
    name: "Mutual of Omaha",
    id: "MO-4465-X",
    icon: "building",
    link: "https://producer.mutualofomaha.com/enterprise/myportal/home/welcome/!ut/p/z1/04_Sj9CPykssy0xPLMnMz0vMAfIjo8zind0dPUzMfQwM3J2NzA0cDbw9vNzcDQwNXA30wwkpiAJKG-AAjiD9UWAlcBMsTI1cwCZYmJoaGxt4mkEV4DGjIDfCINNRUREARwKK3g!!/dz/d5/L2dBISEvZ0FBIS9nQSEh/?iss=https%3A%2F%2Flogin.mutualofomaha.com",
  },
  {
    name: "Royal Neighbors",
    id: "RN-6677-M",
    icon: "users-group",
    link: "https://agent.royalneighbors.org/login",
  },
  {
    name: "Transamerica",
    id: "TA-8899-K",
    icon: "arrows-transfer-up",
    link: "https://secure.transamerica.com/login/sign-in/login.html?_ga=2.137680179.2010337871.1685493287-238019130.1685061717",
  },
];

const iconMap = {
  shield: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3l8 4v5c0 5.25-3.5 10.15-8 11.5C7.5 22.15 4 17.25 4 12V7l8-4z"
      />
    </svg>
  ),
  "shield-check": (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3l8 4v5c0 5.25-3.5 10.15-8 11.5C7.5 22.15 4 17.25 4 12V7l8-4z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
    </svg>
  ),
  "briefcase-medical": (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path strokeLinecap="round" d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
      <path strokeLinecap="round" d="M12 12v4M10 14h4" />
    </svg>
  ),
  users: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <circle cx="9" cy="7" r="3" />
      <path strokeLinecap="round" d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" />
      <path
        strokeLinecap="round"
        d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87"
      />
    </svg>
  ),
  "users-group": (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <circle cx="12" cy="7" r="3" />
      <path strokeLinecap="round" d="M5 21v-2a4 4 0 014-4h6a4 4 0 014 4v2" />
      <circle cx="5" cy="8" r="2" />
      <circle cx="19" cy="8" r="2" />
      <path
        strokeLinecap="round"
        d="M2 21v-1a3 3 0 013-3M22 21v-1a3 3 0 00-3-3"
      />
    </svg>
  ),
  "building-bank": (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        d="M3 21h18M3 10h18M3 7l9-4 9 4M4 10v11M8 10v11M12 10v11M16 10v11M20 10v11"
      />
    </svg>
  ),
  leaf: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <path strokeLinecap="round" d="M5 21C5 13 9 5 21 3c0 12-4 18-16 18z" />
      <path strokeLinecap="round" d="M5 21l7-7" />
    </svg>
  ),
  asterisk: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <path strokeLinecap="round" d="M12 4v16M4 8l16 8M4 16L20 8" />
    </svg>
  ),
  brain: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        d="M9 3a4 4 0 00-4 4c-1.1 0-2 .9-2 2s.9 2 2 2c0 2.2 1.8 4 4 4h6c2.2 0 4-1.8 4-4 1.1 0 2-.9 2-2s-.9-2-2-2a4 4 0 00-4-4H9z"
      />
      <path strokeLinecap="round" d="M12 3v12M9 9h6M9 12h6" />
    </svg>
  ),
  user: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <circle cx="12" cy="7" r="4" />
      <path strokeLinecap="round" d="M4 21v-2a6 6 0 0112 0v2" />
    </svg>
  ),
  building: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <rect x="3" y="3" width="18" height="18" rx="1" />
      <path strokeLinecap="round" d="M9 21V9h6v12M9 9h6M3 9h18" />
    </svg>
  ),
  "arrows-transfer-up": (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 3l-4 4h3v10h2V7h3L7 3zM17 21l4-4h-3V7h-2v10h-3l4 4z"
      />
    </svg>
  ),
};

const statusItems = [
  "System Status",
  "Live Carrier Connections",
  "Available Portals",
  "Secure Session",
  "Database Status",
];

const toolLabels = [
  "Website",
  "Agent Guide",
  "Forms",
  "Commission",
  "Support",
  "Training",
];

function CarrierCard({ name, id, icon, link, pinned, onTogglePin, index }) {
  const [toolsOpen, setToolsOpen] = useState(false);

  const handleLogin = () => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <motion.div
      className="ca-command-card"
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.36, delay: Math.min(index, 16) * 0.035 }}
      whileHover={{ y: -6 }}
    >
      {/* Top row */}
      <div className="ca-card-top">
        <div className="ca-symbol">
          {iconMap[icon] || iconMap["shield"]}
        </div>
        <div className="ca-card-status-stack">
          <button
            className={`ca-pin-btn${pinned ? " pinned" : ""}`}
            type="button"
            onClick={onTogglePin}
            aria-label={pinned ? `Unpin ${name}` : `Pin ${name}`}
          >
            ★
          </button>
          <span className="ca-secure-chip">Secure</span>
        </div>
      </div>

      {/* Name & ID */}
      <div className="ca-card-copy">
        <p className="ca-carrier-name">
          {name}
        </p>
        <p className="ca-carrier-id">
          ID: {id}
        </p>
        <div className="ca-status-row">
          <span>Online</span>
          <span>Ready</span>
          <span>Authorized</span>
        </div>
      </div>

      {/* Login button */}
      <button
        onClick={handleLogin}
        className="ca-login-btn"
      >
        LOGIN
      </button>

      {/* Access Tools */}
      <div
        className={`ca-access-toggle${toolsOpen ? " open" : ""}`}
        onClick={() => setToolsOpen(!toolsOpen)}
      >
        <span>Access Tools</span>
        <span
          className={`ca-chevron${toolsOpen ? " open" : ""}`}
        >
          &#8964;
        </span>
      </div>

      <AnimatePresence initial={false}>
        {toolsOpen && (
          <motion.div
            className="ca-tools-panel"
            initial={{ opacity: 0, height: 0, y: -6 }}
            animate={{ opacity: 1, height: "auto", y: 0 }}
            exit={{ opacity: 0, height: 0, y: -6 }}
            transition={{ duration: 0.18 }}
          >
          {toolLabels.map((t) => (
            <button
              key={t}
              className="ca-tool-pill"
            >
              <span className="ca-tool-dot" />
              {t}
            </button>
          ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export default function CarrierAccessTerminal() {
  const [showBanner] = useState(true);
  const [search, setSearch] = useState("");
  const [panelOpen, setPanelOpen] = useState(true);
  const [pinnedCarriers, setPinnedCarriers] = useState([]);
  const navigate = useNavigate();

  const togglePinned = (id) => {
    setPinnedCarriers((current) =>
      current.includes(id)
        ? current.filter((carrierId) => carrierId !== id)
        : [...current, id]
    );
  };

  const filteredCarriers = [...carriers]
    .filter((carrier) => {
      const query = search.toLowerCase().trim();
      if (!query) return true;
      return `${carrier.name} ${carrier.id} ${carrier.link}`
        .toLowerCase()
        .includes(query);
    })
    .sort((a, b) => {
      const aPinned = pinnedCarriers.includes(a.id);
      const bPinned = pinnedCarriers.includes(b.id);
      if (aPinned !== bPinned) return aPinned ? -1 : 1;
      return a.name.localeCompare(b.name);
    });

  return (
    <div className="ca-page min-h-screen font-mono text-[#00e0ff]">
      <style>{`
        .ca-page {
          position: relative;
          overflow: hidden;
          background:
            radial-gradient(circle at 18% 12%, rgba(0, 224, 255, 0.12), transparent 28%),
            radial-gradient(circle at 78% 4%, rgba(212, 160, 23, 0.1), transparent 25%),
            radial-gradient(circle at 68% 82%, rgba(0, 112, 255, 0.09), transparent 34%),
            #090b0d;
          isolation: isolate;
          animation: ca-page-in 320ms ease both;
        }
        .ca-page::before {
          content: "";
          position: absolute;
          inset: 0;
          z-index: -2;
          pointer-events: none;
          opacity: 0.42;
          background:
            linear-gradient(rgba(0, 224, 255, 0.045) 1px, transparent 1px),
            linear-gradient(90deg, rgba(212, 160, 23, 0.035) 1px, transparent 1px);
          background-size: 42px 42px;
          mask-image: radial-gradient(circle at 50% 18%, black, transparent 74%);
          animation: ca-grid-drift 18s linear infinite;
        }
        .ca-page::after {
          content: "";
          position: absolute;
          width: 44vw;
          min-width: 320px;
          height: 44vw;
          min-height: 320px;
          right: -16vw;
          top: 6vh;
          z-index: -1;
          pointer-events: none;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0, 224, 255, 0.11), rgba(0, 224, 255, 0.02) 42%, transparent 68%);
          filter: blur(2px);
          animation: ca-orb-drift 18s ease-in-out infinite alternate;
        }
        .ca-shell {
          width: min(100%, 1500px);
          margin: 0 auto;
          padding: clamp(18px, 3vw, 34px);
        }
        .ca-header {
          position: relative;
          align-items: center;
          padding: clamp(18px, 3vw, 28px);
          border: 1px solid rgba(0, 224, 255, 0.16);
          border-radius: 18px;
          background: linear-gradient(135deg, rgba(16, 24, 28, 0.78), rgba(8, 10, 12, 0.84));
          box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.04);
          backdrop-filter: blur(14px);
          overflow: hidden;
        }
        .ca-header::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.055) 44%, transparent 62%);
          opacity: 0.55;
        }
        .ca-header-main,
        .ca-directory-link {
          position: relative;
          z-index: 1;
        }
        .ca-logo-mark {
          width: 40px;
          height: 40px;
          border-radius: 12px;
          border: 1px solid rgba(0, 224, 255, 0.28);
          background: radial-gradient(circle, rgba(0, 224, 255, 0.24), transparent 58%), rgba(13, 30, 34, 0.72);
          box-shadow: 0 0 26px rgba(0, 224, 255, 0.12);
        }
        .ca-eyebrow {
          font-size: 10px;
          line-height: 1.35;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: rgba(0, 224, 255, 0.78);
        }
        .ca-title {
          color: #fff;
          font-weight: 900;
          font-size: clamp(24px, 4vw, 42px);
          letter-spacing: 0.08em;
          text-transform: uppercase;
          line-height: 0.98;
        }
        .ca-title::after {
          content: "";
          display: block;
          width: min(220px, 100%);
          height: 1px;
          margin-top: 12px;
          background: linear-gradient(90deg, rgba(0,224,255,0.75), rgba(212,160,23,0.45), transparent);
          animation: ca-line-glow 2.8s ease-in-out infinite;
        }
        .ca-subtitle {
          margin-top: 10px;
          color: rgba(218, 234, 238, 0.66);
          font-size: clamp(11px, 1.5vw, 13px);
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }
        .ca-directory-link {
          border-color: rgba(212, 160, 23, 0.42);
          border-radius: 999px;
          background: rgba(212, 160, 23, 0.06);
          color: #d4a017;
          transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
        }
        .ca-directory-link:hover {
          transform: translateY(-1px);
          border-color: rgba(212, 160, 23, 0.8);
          background: rgba(212, 160, 23, 0.1);
          box-shadow: 0 0 24px rgba(212, 160, 23, 0.11);
        }
        .ca-directory-link svg {
          filter: drop-shadow(0 0 10px rgba(212,160,23,0.32));
        }
        .ca-search-wrap {
          position: relative;
          margin-top: 18px;
        }
        .ca-search-icon,
        .ca-clear-search {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
        }
        .ca-search-icon {
          left: 18px;
          color: rgba(0, 224, 255, 0.72);
        }
        .ca-clear-search {
          right: 12px;
          width: 34px;
          height: 34px;
          border: 1px solid rgba(212, 160, 23, 0.28);
          border-radius: 999px;
          background: rgba(212, 160, 23, 0.08);
          color: #d4a017;
          cursor: pointer;
        }
        .ca-search-input {
          width: 100%;
          min-height: 58px;
          border: 1px solid rgba(0, 224, 255, 0.2);
          border-radius: 16px;
          padding: 0 58px;
          outline: none;
          background: rgba(4, 12, 17, 0.72);
          color: #eafbff;
          font: inherit;
          font-size: 12px;
          letter-spacing: 0.08em;
          transition: border-color 220ms ease, box-shadow 220ms ease, background 220ms ease;
        }
        .ca-search-input::placeholder {
          color: rgba(218, 234, 238, 0.42);
        }
        .ca-search-input:focus {
          border-color: rgba(0, 224, 255, 0.66);
          background: rgba(4, 16, 22, 0.9);
          box-shadow: 0 0 0 4px rgba(0, 224, 255, 0.08), 0 0 34px rgba(0, 224, 255, 0.12);
        }
        .ca-command-bar {
          display: grid;
          grid-template-columns: repeat(5, minmax(0, 1fr));
          gap: 12px;
          margin-top: 18px;
        }
        .ca-status-module {
          border: 1px solid rgba(0, 224, 255, 0.14);
          border-radius: 16px;
          background: linear-gradient(145deg, rgba(12, 28, 34, 0.72), rgba(5, 10, 13, 0.78));
          padding: 14px;
          color: rgba(218, 234, 238, 0.66);
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
        }
        .ca-status-module span {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .ca-status-module span::before,
        .ca-secure-chip::before,
        .ca-status-row span::before {
          content: "";
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #22c55e;
          box-shadow: 0 0 12px rgba(34, 197, 94, 0.8);
          animation: ca-status-pulse 2s ease-in-out infinite;
        }
        .ca-status-module strong {
          display: block;
          margin-top: 8px;
          color: #ffffff;
          font-size: 13px;
          letter-spacing: 0.04em;
        }
        .ca-layout {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);
          gap: 18px;
          align-items: start;
        }
        .ca-directory-label {
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.12em;
          line-height: 1.2;
          text-transform: uppercase;
        }
        .ca-grid-section {
          padding: clamp(18px, 3vw, 34px) 0 56px;
          min-width: 0;
        }
        .ca-grid-label {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 18px;
          color: rgba(0, 224, 255, 0.72);
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 0.2em;
          text-transform: uppercase;
        }
        .ca-grid-label::after {
          content: "";
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, rgba(0, 224, 255, 0.36), transparent);
        }
        .ca-carrier-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr)) !important;
          gap: clamp(14px, 2vw, 20px);
        }
        .ca-command-card {
          position: relative;
          min-width: 0;
          min-height: 238px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding: clamp(18px, 2.2vw, 22px);
          border: 1px solid rgba(0, 224, 255, 0.14);
          border-radius: 18px;
          background: linear-gradient(145deg, rgba(22, 32, 36, 0.74), rgba(9, 12, 14, 0.88)), rgba(10, 12, 14, 0.86);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.045), 0 18px 48px rgba(0, 0, 0, 0.22);
          overflow: hidden;
          backdrop-filter: blur(14px);
          animation: ca-card-enter 420ms ease both;
        }
        .ca-command-card::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.08) 42%, transparent 58%);
          transform: translateX(-120%);
          transition: transform 0.75s ease;
        }
        .ca-command-card::after {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: inherit;
          padding: 1px;
          background: linear-gradient(120deg, transparent, rgba(0, 224, 255, 0.45), transparent, rgba(212, 160, 23, 0.32), transparent);
          -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          opacity: 0;
          transition: opacity 220ms ease;
          pointer-events: none;
        }
        .ca-command-card:hover {
          transform: translateY(-4px);
          border-color: rgba(0, 224, 255, 0.52);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 24px 58px rgba(0, 0, 0, 0.32), 0 0 26px rgba(0, 224, 255, 0.11);
        }
        .ca-command-card:hover::before {
          transform: translateX(120%);
        }
        .ca-command-card:hover::after {
          opacity: 1;
        }
        .ca-card-top {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
        }
        .ca-symbol {
          width: 48px;
          height: 48px;
          border: 1px solid rgba(0, 224, 255, 0.22);
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #00e0ff;
          background: radial-gradient(circle at 35% 28%, rgba(0, 224, 255, 0.22), transparent 54%), linear-gradient(145deg, rgba(17, 38, 44, 0.82), rgba(7, 13, 16, 0.88));
          box-shadow: 0 0 18px rgba(0, 224, 255, 0.09);
          transition: transform 0.2s ease, filter 0.2s ease;
        }
        .ca-command-card:hover .ca-symbol {
          transform: scale(1.05);
          filter: drop-shadow(0 0 10px rgba(0, 224, 255, 0.24));
        }
        .ca-secure-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: rgba(212, 160, 23, 0.9);
          background: rgba(212, 160, 23, 0.07);
          border: 1px solid rgba(212, 160, 23, 0.22);
          border-radius: 999px;
          font-size: 8px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          padding: 5px 8px;
        }
        .ca-card-status-stack {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .ca-pin-btn {
          width: 28px;
          height: 28px;
          border: 1px solid rgba(0, 224, 255, 0.18);
          border-radius: 999px;
          background: rgba(0, 224, 255, 0.04);
          color: rgba(218, 234, 238, 0.38);
          cursor: pointer;
          transition: transform 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
        }
        .ca-pin-btn:hover,
        .ca-pin-btn.pinned {
          transform: scale(1.08);
          color: #d4a017;
          border-color: rgba(212, 160, 23, 0.62);
          box-shadow: 0 0 18px rgba(212, 160, 23, 0.18);
        }
        .ca-card-copy {
          min-height: 54px;
        }
        .ca-carrier-name {
          color: #ffffff;
          font-weight: 800;
          font-size: clamp(14px, 1.6vw, 16px);
          letter-spacing: 0.08em;
          line-height: 1.22;
          text-transform: uppercase;
        }
        .ca-carrier-id {
          color: rgba(0, 224, 255, 0.36);
          font-size: 10px;
          letter-spacing: 0.12em;
          margin-top: 7px;
        }
        .ca-status-row {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin-top: 12px;
        }
        .ca-status-row span {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          border: 1px solid rgba(0, 224, 255, 0.12);
          border-radius: 999px;
          padding: 5px 7px;
          color: rgba(218, 234, 238, 0.62);
          background: rgba(0, 224, 255, 0.04);
          font-size: 8px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }
        .ca-login-btn {
          position: relative;
          overflow: hidden;
          width: 100%;
          border: 1px solid rgba(0, 224, 255, 0.52);
          border-radius: 10px;
          color: #dffbff;
          background: linear-gradient(135deg, rgba(0, 224, 255, 0.11), rgba(0, 224, 255, 0.035));
          font-weight: 900;
          font-size: 11px;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          padding: 11px 12px;
          cursor: pointer;
          font-family: inherit;
          transition: transform 0.16s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease;
        }
        .ca-login-btn::before {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(110deg, transparent, rgba(255,255,255,0.34), transparent);
          transform: translateX(-120%);
          transition: transform 0.5s ease;
        }
        .ca-login-btn:hover::before {
          transform: translateX(120%);
        }
        .ca-login-btn:hover {
          transform: scale(1.02);
          border-color: #00e0ff;
          background: rgba(0, 224, 255, 0.16);
          box-shadow: 0 0 22px rgba(0, 224, 255, 0.16);
        }
        .ca-login-btn:active {
          transform: scale(0.98);
        }
        .ca-access-toggle {
          margin-top: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          border-top: 1px solid rgba(0, 224, 255, 0.12);
          padding-top: 13px;
          color: rgba(202, 232, 238, 0.58);
          font-size: 10px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          cursor: pointer;
          transition: color 0.18s ease;
        }
        .ca-access-toggle:hover,
        .ca-access-toggle.open {
          color: #00e0ff;
        }
        .ca-chevron {
          transition: transform 0.18s ease;
        }
        .ca-chevron.open {
          transform: rotate(180deg);
        }
        .ca-tools-panel {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          border-top: 1px solid rgba(0, 224, 255, 0.1);
          padding-top: 12px;
          animation: ca-tools-open 180ms ease both;
          overflow: hidden;
        }
        .ca-tool-pill {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          border: 1px solid rgba(0, 224, 255, 0.16);
          border-radius: 999px;
          background: rgba(0, 224, 255, 0.045);
          color: rgba(202, 232, 238, 0.68);
          cursor: pointer;
          font-family: inherit;
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 8px 9px;
          transition: color 0.18s ease, border-color 0.18s ease, background 0.18s ease;
        }
        .ca-tool-dot {
          width: 5px;
          height: 5px;
          border-radius: 999px;
          background: rgba(0, 224, 255, 0.74);
          box-shadow: 0 0 8px rgba(0, 224, 255, 0.42);
        }
        .ca-ops-panel {
          position: sticky;
          top: 18px;
          margin-top: clamp(18px, 3vw, 34px);
          border: 1px solid rgba(0, 224, 255, 0.16);
          border-radius: 20px;
          background: linear-gradient(145deg, rgba(16, 24, 28, 0.78), rgba(8, 10, 12, 0.86));
          box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.04);
          backdrop-filter: blur(14px);
          overflow: hidden;
        }
        .ca-ops-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 18px;
          border-bottom: 1px solid rgba(0, 224, 255, 0.12);
        }
        .ca-ops-head h2 {
          margin: 0;
          color: #ffffff;
          font-size: 13px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
        }
        .ca-ops-toggle {
          border: 1px solid rgba(212, 160, 23, 0.28);
          border-radius: 999px;
          background: rgba(212, 160, 23, 0.08);
          color: #d4a017;
          cursor: pointer;
          padding: 7px 10px;
          font: inherit;
          font-size: 10px;
        }
        .ca-ops-body {
          display: grid;
          gap: 10px;
          padding: 16px;
        }
        .ca-ops-widget {
          border: 1px solid rgba(0, 224, 255, 0.12);
          border-radius: 14px;
          background: rgba(0, 224, 255, 0.035);
          padding: 12px;
        }
        .ca-ops-widget span {
          display: block;
          color: rgba(0, 224, 255, 0.68);
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          margin-bottom: 7px;
        }
        .ca-ops-widget strong,
        .ca-ops-widget p {
          color: rgba(234, 248, 255, 0.82);
          font-size: 12px;
          line-height: 1.5;
          margin: 0;
        }
        .ca-empty {
          border: 1px dashed rgba(0, 224, 255, 0.2);
          border-radius: 18px;
          padding: 40px 18px;
          text-align: center;
          color: rgba(218, 234, 238, 0.42);
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        .ca-tool-pill:hover {
          border-color: rgba(0, 224, 255, 0.55);
          color: #00e0ff;
          background: rgba(0, 224, 255, 0.09);
        }
        @keyframes ca-page-in {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes ca-card-enter {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes ca-tools-open {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes ca-orb-drift {
          from { transform: translate3d(0, 0, 0) scale(1); }
          to { transform: translate3d(-8vw, 5vh, 0) scale(1.08); }
        }
        @keyframes ca-grid-drift {
          from { background-position: 0 0; }
          to { background-position: 42px 42px; }
        }
        @keyframes ca-line-glow {
          0%, 100% { opacity: 0.55; }
          50% { opacity: 1; }
        }
        @keyframes ca-status-pulse {
          0%, 100% { opacity: 0.72; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.16); }
        }
        @media (max-width: 1180px) {
          .ca-layout {
            grid-template-columns: 1fr;
          }
          .ca-ops-panel {
            position: relative;
            top: auto;
            margin-top: 0;
          }
        }
        @media (max-width: 980px) {
          .ca-command-bar {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }
        @media (max-width: 760px) {
          .ca-header {
            border-radius: 14px;
          }
          .ca-title {
            letter-spacing: 0.05em;
          }
          .ca-directory-link {
            width: 100%;
            justify-content: center;
            border-radius: 12px;
          }
          .ca-tools-panel {
            grid-template-columns: 1fr;
          }
        }
        @media (max-width: 480px) {
          .ca-shell {
            padding: 14px;
          }
          .ca-header {
            padding: 18px;
          }
          .ca-logo-mark {
            width: 34px;
            height: 34px;
          }
          .ca-command-card {
            min-height: 220px;
          }
          .ca-command-bar {
            grid-template-columns: 1fr;
          }
          .ca-search-input {
            padding-left: 48px;
            padding-right: 48px;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .ca-page,
          .ca-page::after,
          .ca-command-card,
          .ca-command-card::before,
          .ca-tools-panel {
            animation: none !important;
            transition: none !important;
            transform: none !important;
          }
        }
      `}</style>
      <div className="ca-shell">
      {/* Header */}
      <header className="ca-header flex flex-wrap items-center justify-between gap-4">
        {/* Left */}
        <div className="ca-header-main flex flex-wrap items-center gap-4">
          {/* Logo dot + label */}
          <div className="flex items-center gap-2">
            <span className="ca-logo-mark inline-block" />
            <span className="ca-eyebrow">
              Secure Access
              <br />
              Portal
            </span>
          </div>

          {/* Title */}
          <div>
            <h1 className="ca-title">Carrier Command Center</h1>
            <p className="ca-subtitle">
              Secure carrier authentication, underwriting resources, login
              portals and cancellation tools.
            </p>
          </div>
        </div>

        {/* Right — Operational Directory */}
        {showBanner && (
          <div
            onClick={() => navigate("/cancelation-form-directory")}
            className="ca-directory-link flex items-center gap-3 border px-4 py-3 cursor-pointer"
          >
            <div>
              <p className="ca-directory-label">
                Cancellation Form Directory
              </p>
            </div>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <path d="M14 2v6h6" />
              <path d="M9 14h6M9 18h4" />
            </svg>
            <button
              // onClick={() => setShowBanner(false)}
              className="hidden text-sm opacity-60 hover:opacity-100 transition-opacity ml-2 bg-transparent border-none text-[#00e0ff] cursor-pointer"
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        )}
      </header>

      <div className="ca-search-wrap">
        <span className="ca-search-icon">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </span>
        <input
          className="ca-search-input"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search carriers, underwriting tools or login portals..."
          aria-label="Search carriers, underwriting tools or login portals"
        />
        {search && (
          <button
            type="button"
            className="ca-clear-search"
            onClick={() => setSearch("")}
            aria-label="Clear carrier search"
          >
            X
          </button>
        )}
      </div>

      <div className="ca-command-bar">
        {statusItems.map((item, index) => (
          <motion.div
            className="ca-status-module"
            key={item}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.04, duration: 0.28 }}
          >
            <span>{item}</span>
            <strong>
              {item === "Available Portals"
                ? carriers.length
                : item === "Live Carrier Connections"
                ? filteredCarriers.length
                : "Online"}
            </strong>
          </motion.div>
        ))}
      </div>

      <div className="ca-layout">
        {/* Grid */}
        <main className="ca-grid-section">
          <div className="ca-grid-label">Carrier Command Grid</div>
          {filteredCarriers.length > 0 ? (
            <div className="ca-carrier-grid">
              {filteredCarriers.map((c, index) => (
                <CarrierCard
                  key={c.id}
                  {...c}
                  index={index}
                  pinned={pinnedCarriers.includes(c.id)}
                  onTogglePin={() => togglePinned(c.id)}
                />
              ))}
            </div>
          ) : (
            <div className="ca-empty">No carrier portals match search.</div>
          )}
        </main>

        <aside className="ca-ops-panel">
          <div className="ca-ops-head">
            <h2>Live Operations</h2>
            <button
              type="button"
              className="ca-ops-toggle"
              onClick={() => setPanelOpen((open) => !open)}
            >
              {panelOpen ? "Collapse" : "Open"}
            </button>
          </div>
          <AnimatePresence initial={false}>
            {panelOpen && (
              <motion.div
                className="ca-ops-body"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.2 }}
              >
                <div className="ca-ops-widget">
                  <span>Recent Carrier Accessed</span>
                  <strong>{filteredCarriers[0]?.name || "Awaiting selection"}</strong>
                </div>
                <div className="ca-ops-widget">
                  <span>Favorite Carriers</span>
                  <p>
                    {pinnedCarriers.length
                      ? `${pinnedCarriers.length} pinned`
                      : "Pin carriers with the star."}
                  </p>
                </div>
                <div className="ca-ops-widget">
                  <span>Quick Notes</span>
                  <p>Keep carrier-specific reminders ready for field use.</p>
                </div>
                <div className="ca-ops-widget">
                  <span>Pinned Carriers</span>
                  <p>
                    {pinnedCarriers
                      .map((id) => carriers.find((carrier) => carrier.id === id)?.name)
                      .filter(Boolean)
                      .join(", ") || "None"}
                  </p>
                </div>
                <div className="ca-ops-widget">
                  <span>Agency Alerts</span>
                  <p>Secure session active. Portal directory verified.</p>
                </div>
                <div className="ca-ops-widget">
                  <span>Today's Updates</span>
                  <p>{filteredCarriers.length} carrier modules available.</p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </aside>
      </div>
      </div>
    </div>
  );
}
